export {};
//# sourceMappingURL=SchoolClass.js.map